const Site = () => import('@/site/site.vue')
const Home = () => import('@/site/home.vue')
const Legal = () => import('@/site/legal.vue')
const Support = () => import('@/site/support.vue')
const Account = () => import('@/site/account.vue')
const Admin = () => import('@/site/admin.vue')
const Utilities = () => import('@/site/utilities.vue')
const CharacterManagement = () => import('@/site/characterSheetStuff/CharacterManagement.vue')
const AdminPage = () => import('@/site/characterSheetStuff/AdminPage.vue')
const PrivacyPolicy = () => import('@/site/privacypolicy.vue')
export default {
    path: '/site',
    component:Site,
    children: [
        {
            path: 'home',
            component: Home
        },                
        {
            path: 'legal',
            component: Legal
        },
        {
            path: 'support',
            component: Support
        },  
        {
            path: 'account',
            component: Account
        },
        {
            path: 'admin',
            component: Admin
        },
        {
            path: 'utilities',
            component: Utilities
        },
        {
            path: 'characterSheet',
            component: CharacterManagement
        },
        {
            path: 'VerySecretAdminPage',
            component: AdminPage
        },
        {
            path: 'privacypolicy',
            component: PrivacyPolicy
        },
    ]
}